import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionAddonSubscribedText = styled.div.attrs({
  id: 'descriptionAddonSubscribedText',
})<React.CSSProperties>`
  font-family: ${Fonts['bold']};
  color: ${Colors['promo']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-bottom: ${Screen.widthRatio * 12}px;
  width: ${Screen.widthRatio * 820}px;
`;

export default DescriptionAddonSubscribedText;
